<template>
  <div class="about" v-if="!$root.loading">
    <Banner :msg="breadcrumbTitle" :data="breadcumb"></Banner>
    <div class="contact py-4">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <div class="card shadow-sm h-100">
              <div class="card-header m-3">
                <h4 class="m-0 font-weight-bold">Contact Form</h4>
              </div>

              <form @submit.prevent="submitForm" class="card-body" novalidate>
                <div class="controls">
                  <div style="display: none;">
                    <input
                      type="text"
                      v-model="form.website"
                      autocomplete="off"
                      tabindex="-1"
                    />
                  </div>

                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label-sm m-0">
                          Name <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          v-model.trim="form.name"
                          @input="validateField('name')"
                          @blur="validateField('name')"
                          placeholder="Enter your firstname"
                          class="form-control form-control-sm shadow-none"
                          :class="{ 'is-invalid': errors.name }"
                        />
                        <small v-if="errors.name" class="text-danger">
                          {{ errors.name }}
                        </small>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="form-group">
                        <label class="col-form-label-sm m-0">
                          Last Name <span class="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          name="surname"
                          id="surname"
                          v-model.trim="form.surname"
                          @input="validateField('surname')"
                          @blur="validateField('surname')"
                          placeholder="Enter your lastname"
                          class="form-control form-control-sm shadow-none"
                          :class="{ 'is-invalid': errors.surname }"
                        />
                        <small v-if="errors.surname" class="text-danger">
                          {{ errors.surname }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label-sm m-0">
                      Email <span class="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      v-model.trim="form.email"
                      @input="validateField('email')"
                      @blur="validateField('email')"
                      placeholder="Enter your email"
                      class="form-control form-control-sm shadow-none"
                      :class="{ 'is-invalid': errors.email }"
                    />
                    <small v-if="errors.email" class="text-danger">
                      {{ errors.email }}
                    </small>
                  </div>

                  <div class="form-group">
                    <label class="col-form-label-sm m-0">
                      Message <span class="text-danger">*</span>
                    </label>
                    <textarea
                      rows="4"
                      name="message"
                      id="message"
                      v-model.trim="form.message"
                      @input="validateField('message')"
                      @blur="validateField('message')"
                      placeholder="Enter your message"
                      class="form-control form-control-sm shadow-none"
                      :class="{ 'is-invalid': errors.message }"
                    ></textarea>
                    <small v-if="errors.message" class="text-danger">
                      {{ errors.message }}
                    </small>
                  </div>

                  <button
                    type="submit"
                    class="btn bg-theme3 text-white lift"
                    :disabled="sending"
                  >
                    {{ sending ? "Sending..." : "Send message" }}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="col-md-7">
            <div class="card shadow-sm card-body h-100">
              <h4 class="font-weight-bold">Address</h4>
              <p class>{{ contact.address }}</p>
              <p class>Telephone: {{ contact.phone }}</p>
              <p class>E-mail: {{ contact.email }}</p>
              <div v-html="contact.google_location"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Banner from "./pages/Banner.vue";

export default {
  name: "Content Details",
  components: {
    Banner
  },
  data() {
    return {
      contact: {},
      breadcrumbTitle: "",
      breadcumb: [],
      sending: false,
      errors: {},
      form: {
        name: "",
        surname: "",
        email: "",
        message: "",
        website: ""
      }
    };
  },
  methods: {
    asyncData() {
      this.get_data();
    },

    get_data() {
      this.$root.loading = true;
      axios
        .get(window.laravel.baseurl + "/home/contact")
        .then(respons => {
          this.breadcumb = [{ title: "Contact" }];
          this.contact = respons.data.result;
          this.breadcrumbTitle = "Contact";
          this.$root.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.$root.loading = false;
        });
    },

    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    },

    validateField(field) {
      if (field === "name") {
        if (!this.form.name) {
          this.$set(this.errors, "name", "Name is required.");
        } else {
          this.$delete(this.errors, "name");
        }
      }

      if (field === "surname") {
        if (!this.form.surname) {
          this.$set(this.errors, "surname", "Last name is required.");
        } else {
          this.$delete(this.errors, "surname");
        }
      }

      if (field === "email") {
        if (!this.form.email) {
          this.$set(this.errors, "email", "Email is required.");
        } else if (!this.isValidEmail(this.form.email)) {
          this.$set(this.errors, "email", "Please enter a valid email address.");
        } else {
          this.$delete(this.errors, "email");
        }
      }

      if (field === "message") {
        if (!this.form.message) {
          this.$set(this.errors, "message", "Message is required.");
        } else if (this.form.message.length < 5) {
          this.$set(this.errors, "message", "Message must be at least 5 characters.");
        } else {
          this.$delete(this.errors, "message");
        }
      }
    },

    validateForm() {
      this.validateField("name");
      this.validateField("surname");
      this.validateField("email");
      this.validateField("message");

      return Object.keys(this.errors).length === 0;
    },

    submitForm() {
      if (!this.validateForm()) {
        Swal.fire({
          icon: "error",
          title: "Validation Error",
          text: "Please fill in all required fields correctly.",
          confirmButtonColor: "#d33"
        });
        return;
      }

      this.sending = true;

      axios
        .post(window.laravel.baseurl + "/contact-submit", this.form)
        .then(response => {
          Swal.fire({
            icon: "success",
            title: "Message Sent!",
            text:
              response.data.success ||
              "Your message has been sent successfully.",
            confirmButtonColor: "#3085d6"
          });

          this.errors = {};
          this.form = {
            name: "",
            surname: "",
            email: "",
            message: "",
            website: ""
          };
        })
        .catch(error => {
          let msg = "Failed to send message. Please try again.";

          if (error.response && error.response.data) {
            if (error.response.status === 429) {
              msg = "Too many attempts. Please wait a minute and try again.";
            } else if (error.response.data.errors) {
              const serverErrors = error.response.data.errors;
              Object.keys(serverErrors).forEach(key => {
                this.$set(this.errors, key, serverErrors[key][0]);
              });
              msg = "Please correct the highlighted fields.";
            } else if (error.response.data.message) {
              msg = error.response.data.message;
            }
          }

          Swal.fire({
            icon: "error",
            title: "Error!",
            text: msg,
            confirmButtonColor: "#d33"
          });
        })
        .finally(() => {
          this.sending = false;
        });
    }
  },

  mounted() {
    this.get_data();
    this.$root.loading = false;
  },

  created() {
    this.$root.loading = true;
  }
};
</script>
